import ClientMessage from './clientmessage'
import './styles.css'
import { useEffect, useMemo, useRef, useState } from 'react'
import botIcon from '../../../images/logo-icon.png'
import { getPrevMessages } from '../../../services/chat_api'
import Cookies from 'js-cookie'

let now = new Date()
now = now.getHours()
let wellcome = ''

if (now > 5 && now <= 12) {
	wellcome = 'Bom dia'
}
if (now > 12 && now <= 18) {
	wellcome = 'Boa tarde'
}
if (now > 18 || now <= 5) {
	wellcome = 'Boa noite'
}
const userCookie = Cookies.get('user')
let parsedName = 'User'
if (userCookie) {
	parsedName = JSON.parse(userCookie).name
}
const clientName = parsedName.split('')[0].toUpperCase() + parsedName.slice(1)

const Chat = ({ selected, currentPage, setCurrentPage }) => {
	const [prevMessages, setPrevMessages] = useState([])
	const [newMessages, setNewMessages] = useState([])
	const messageRef = useRef()
	const anchorRef = useRef()

	useEffect(() => {
		const observer = new IntersectionObserver((entries) => {
			if (entries.some((entry) => entry.isIntersecting)) {
				console.log('showing..')
				setCurrentPage((prev) => prev + 1)
			}
		})
		setTimeout(() => {
			observer.observe(document.querySelector('#ward'))
		}, 3000)
		return () => observer.disconnect()
	}, [])

	let token = Cookies.get('access_token')
	if (token) {
		token = JSON.parse(token)
	}

	const wsurl = useMemo(() => `wss://api.schiefler.adv.br/chat/connect/ws/room/${selected.id}?token=${token}`, [])

	const ws = useMemo(() => {
		console.log('new conection')
		return new WebSocket(wsurl)
	}, [])

	ws.onmessage = function (event) {
		const received = JSON.parse(event.data).message
		setPrevMessages((prev) => [...prev, received])
		setNewMessages(received)
	}

	useEffect(() => {
		anchorRef.current.focus()
		messageRef.current.focus()
	}, [newMessages])

	function sendMessage() {
		if (messageRef.current.value === '') {
			return
		}

		const message = { message: { text: messageRef.current.value } }
		ws.send(JSON.stringify(message))
		const text = message.message
		text.sent_by = 'user@user'
		messageRef.current.value = ''
		window.location.href = '#anchor'
		setTimeout(() => {
			messageRef?.current.focus()
		}, 300)
	}

	const getMessages = async ({ reset }) => {
		messageRef.current.value = ''
		if (reset) {
			const response = await getPrevMessages({ room_id: selected.id, currentPage: 0 })
			setNewMessages([])
			setPrevMessages(response.messages.reverse())
			setTimeout(() => {
				anchorRef?.current.focus()
				messageRef?.current.focus()
			}, 500)
			return
		}
		const response = await getPrevMessages({ room_id: selected.id, currentPage })
		if (response.messages.length === 0) {
			return
		} else if (currentPage === 0) {
			setNewMessages([])
			setPrevMessages(response.messages.reverse())
			setTimeout(() => {
				anchorRef?.current.focus()
				messageRef?.current.focus()
			}, 500)
		} else {
			setPrevMessages((prev) => [...response.messages.reverse(), ...prev])
		}
	}
	useEffect(() => {
		if (currentPage === 0) {
			return
		}
		getMessages({ reset: false })
	}, [currentPage])

	useEffect(() => {
		setPrevMessages([])
		setCurrentPage(0)
		getMessages({ reset: true })
	}, [selected])

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault()
			document.querySelector('.sendMessageBtn').click()
		}
	}
	return (
		<div id="chat">
			<div className="chatHeader">
				<div className="logoPlusText">
					<img className="botIcon headerIcon" src={botIcon}></img>
					<span className="chatTitle">Schiefler Advocacia</span>
					<span className="projectName">{selected.name}</span>
				</div>
			</div>

			<div className="chatBody">
				<div className="marginAutoContainer">
					<div id="ward"></div>
					{prevMessages?.map((message) => (
						<ClientMessage message={message} />
					))}
					<div tabIndex={0} ref={anchorRef}></div>
				</div>
			</div>

			<div className="submitContainer">
				<textarea
					tabIndex={1}
					ref={messageRef}
					onKeyDown={handleKeyDown}
					placeholder="Escreva sua mensagem"
					type="textarea"
					className="textInput"
				/>
				<a className="anchor" href="#anchor">
					<span className="material-symbols-outlined sendMessageBtn" onClick={sendMessage}>
						Send
					</span>
				</a>
			</div>
		</div>
	)
}

export default Chat
